import React from 'react'
import { Parallax } from 'react-parallax';

export default function BgParallax({bg}) {
  return (
    <Parallax bgImage={bg} bgImageAlt="the cat" strength={200} className='position-absolute w-100 h-100 top-0' style={{backgroundPosition:'center'}}>
    </Parallax>
  )
}
